import {
  Flex,
  Heading,
  Card,
  Text,
  Button,
  View,
  TextAreaField,
  Label,
  Badge,
} from "@aws-amplify/ui-react";
import { HealthProviderDetails } from "../../ui-components";
import { useNavigate, useParams } from "react-router-dom";
import { useUserQuery } from "../common/useUserQuery";
import { useCareProviderQuery } from "./api/useCareProvidersQuery";
import { useCareNotesQuery } from "../common/api/useCareNotesQuery";
import CareNotesCard from "../common/CareNotesCard";
import { useEncountersByProviderIdQuery } from "../encounters/api/useEncountersQuery";

const HealthProviderDetailsPage = () => {
  const params = useParams();
  const { data: userData } = useUserQuery();
  const {
    data: careProviderData,
    isFetching,
    error,
  } = useCareProviderQuery(userData?.patientUserId, params.id);
  const { data: encountersData } = useEncountersByProviderIdQuery(
    userData?.patientUserId,
    params.id
  );
  const navigate = useNavigate();

  if (isFetching) return "Loading...";

  if (error) return "An error happened...";

  if (careProviderData) {
    return (
      <Flex
        direction="column"
        position="relative"
        padding="32px 32px 32px 32px"
        backgroundColor="rgba(250,250,250,1)"
      >
        <Flex direction="row">
          <Heading level="1" children="Health Provider Details"></Heading>
        </Flex>
        <Flex direction="row">
          <Flex direction="column">
            <Card variation="elevated">
              <Heading level={5} children={careProviderData?.providerName} />
              <Text children={careProviderData?.providerSpecialty} />
              <Text children={careProviderData?.providerSubSpecialty} />
              <Text children={`Added at: ${careProviderData?.createdAt}`} />
              <Flex gap={9} marginTop={12}>
                <Button
                  size="small"
                  onClick={() =>
                    navigate(`/user/hr/health-providers/${params.id}/edit`)
                  }
                >
                  Edit
                </Button>
              </Flex>
            </Card>
            <Card variation="elevated">
              <Flex justifyContent={"flex-start"} alignItems={"center"}>
                <Heading children="Encounters" />
                <Button
                  size="small"
                  children="Add"
                  onClick={() =>
                    navigate(`/user/hr/encounter/${params.id}/add`)
                  }
                />
              </Flex>

              {encountersData?.map((encounter) => {
                return (
                  <Card
                    variation="outlined"
                    margin={12}
                    key={`hpdp_eid_${encounter?.id}`}
                  >
                    <Flex>
                      <Flex direction="column">
                        <Badge size="small">
                          Overall status: {encounter?.overallStatus}
                        </Badge>
                        <Text
                          variation="primary"
                          fontSize="1em"
                          children={encounter?.outcomeText}
                        />
                      </Flex>
                      <Flex direction="column">
                        <Text
                          variation="info"
                          fontSize="0.85em"
                          children={`DATE: ${encounter?.createdAt}`}
                        />
                        <Flex
                          justifyContent={"flex-end"}
                          alignItems={"flex-end"}
                          grow={1}
                        >
                          <Button
                            size="small"
                            children="Edit"
                            variation="primary"
                            onClick={() =>
                              navigate(
                                `/user/hr/encounter/${encounter?.id}/edit`
                              )
                            }
                          />
                        </Flex>
                      </Flex>
                    </Flex>
                  </Card>
                );
              })}
            </Card>
          </Flex>
        </Flex>
      </Flex>
    );
  }
};

export default HealthProviderDetailsPage;
